// TODO pro-patient-page: proper statuses
export const patientStatusesArray = ['ACTIVE', 'INACTIVE'] as const;

export type PatientStatus = typeof patientStatusesArray[number];
